/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React, { useEffect } from 'react';
import { useStoreDispatch } from '../store/hooks';
import { logout } from "../store/api/auth/reducer";
import { ROUTES } from '../globals/globals';
import { useGetSsoEnabledMutation } from '../store/api/auth/authApiSlice';

const LogoutPage: React.FC = () => {
  const dispatch = useStoreDispatch();
  const [getSsoEnabled] = useGetSsoEnabledMutation();

  useEffect(() => {
    const performLogout = async () => {
      let redirectToSso = false;
      try {
        const ssoResponse: any = await getSsoEnabled();
        redirectToSso = ssoResponse?.data?.status === 200;
      } catch {
        // fall back to login page
      }
      dispatch(logout());
      window.location.replace(redirectToSso ? '/v1/login/saml2/sso' : ROUTES.LOGIN.Path);
    };
    void performLogout();
  }, [dispatch, getSsoEnabled]);

  return null;
}

export default LogoutPage;